//#region types
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { MaxFileSize } from "utils/constants/fileConstants";
import { FileUploaderProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import useFileViewerContext from "../../fileViewer/context/useContext";
import FileViewerContainer from "../../fileViewer/fileViewerContainer";
import * as FileUploader from "../../forms/baseFields/fileUploader";
import { Portal } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { FileHelper } from "utils/helpers";

function FileUploaderComponent(props: FileUploaderProps) {
  const { value, disabled, readonly, setTouched, setValue } = props;

  const { setUploadedFileDimensions } = useFileViewerContext();
  const previewElement = props.filePreviewElementId ? document.getElementById(props.filePreviewElementId) : undefined;

  const onChangeCustom = (data: any, setTouchedValue?: boolean) => {
    setTouched(setTouchedValue ?? false, false);
    setValue(data, true);
  };

  const onBlurCustom = () => {
    setTouched(true);
  };

  const onFilesUpdated = (uploadedFiles?: UploadedFile[]) => {
    onChangeCustom(uploadedFiles);
    onBlurCustom();
  };

  const onCancelUpload = (index: number) => {
    if (index > -1) {
      const updatedFileList: UploadedFile[] = [...(value ?? [])];
      updatedFileList.splice(index, 1);
      onChangeCustom(updatedFileList);

      if (updatedFileList.length === 0) {
        setUploadedFileDimensions();
      }
    }
  };

  return (
    <>
      {previewElement && value?.length ? (
        <Portal container={previewElement}>
          <FileViewerContainer
            meta={value.map(
              (file: UploadedFile): ImageMeta => ({
                id: file.id ?? 0,
                data: file.data,
                contentType: file.contentType,
                numberOfPages: 1,
                locked: file.locked,
              })
            )}
            onDeleteClick={onCancelUpload}
            className={cssExports.uploaderPreviewContainer}
          />
        </Portal>
      ) : (
        <></>
      )}

      <FileViewerContainer
        meta={value?.map(
          (file: UploadedFile): ImageMeta => ({
            id: file.id ?? 0,
            data: file.data,
            contentType: file.contentType,
            numberOfPages: 1,
            locked: file.locked,
          })
        )}
        onDeleteClick={onCancelUpload}
        className={cssExports.uploaderPreviewContainer}
      >
        <FileUploader.FileUploaderContainer
          fileUploaderType={props.fileUploaderType}
          disabled={disabled}
          readonly={readonly}
          filesToUpload={value !== undefined ? value : []}
          onFilesUpdated={onFilesUpdated}
          onCancelUpload={onCancelUpload}
          {...FileHelper.getFileUploaderTypeOptions(props)}
          maxFileSize={props.maxFileSize ?? MaxFileSize}
          singleSelection={props.singleSelection}
          maxFileCount={props.maxFileCount}
          data-testid={`${props.name}FileUploader`}
        />
      </FileViewerContainer>
    </>
  );
}

export default FileUploaderComponent;
